<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <div class="row">
            <h3
              class="ml-md-3 ml-1 mb-md-0"
              :class="type === 'dark' ? 'text-white' : ''"
            >
              {{ title }}
            </h3>
          </div>
        </div>
        <div class="col-6 text-right"></div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="insurances"
      >
        <template slot="columns">
          <th>ชื่อสกุล</th>
          <th>ทะเบียน</th>
          <th>วันเริ่มสัญญา</th>
          <th>วันหมดสัญญา</th>
          <th>เบอร์โทร</th>
          <th>Agent</th>
          <th>ไฟล์</th>
          <th>พนักงาน</th>
          <th></th>
        </template>

        <template slot-scope="{ row }">
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm"
                  >{{ row.name_prefix }} {{ row.name }}</span
                >
              </div>
            </div>
          </th>
          <td class="budget">
            {{ row.license_plate }}
          </td>
          <td>
            {{ formatDate(row.cover_start_date) }}
          </td>
          <td>
            {{ formatDate(row.cover_end_date) }}
          </td>
          <td>
            {{ row.tel }}
          </td>
          <td>
            {{ row.get_agent ? row.get_agent.name : "" }}
          </td>
          <td class="td-normal">
            <span :class="row.document === null ? 'invisible' : ''">
              <img
                src="/img/brand/ic_pdf.png"
                width="16"
                height="16"
                alt="เอกสารพรบ."
              />
              <a href="#" @click="openFile(row.document)" class="ml-2">{{
                row.policy_number
              }}</a>
            </span>
          </td>
          <td class="td-normal">
            {{ row.get_employee ? row.get_employee.name : "" }}
          </td>
        </template>
      </base-table>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    ></div>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
import kickMixin from "../../mixins/kickMixin";
import XLSX from "xlsx";

moment.locale("th");

export default {
  name: "insurance-table",
  mixins: [kickMixin],
  props: {
    type: {
      type: String,
    },
    title: String,
    insurances: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {
      lvl: 0,
      selectedMonth: -1,
      selectedYear: -1,
      selectedAgent: "",
      masterAgent: [],
      masterYear: [
        moment().year() - 5 + 543,
        moment().year() - 4 + 543,
        moment().year() - 3 + 543,
        moment().year() - 2 + 543,
        moment().year() - 1 + 543,
        moment().year() + 543,
        moment().year() + 1 + 543,
        moment().year() + 2 + 543,
        moment().year() + 3 + 543,
        moment().year() + 4 + 543,
        moment().year() + 5 + 543,
      ],
      masterMonth: [],
    };
  },
  methods: {
    formatDate(date) {
      let monthNames = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ];

      let day = moment(date).date();
      let month = monthNames[moment(date).month()];
      let year = moment(date).year() + 543;

      // let parsedDate = Date.parse(date);
      // let newDate = new Date(parsedDate);
      // let day = newDate.getDate();
      // let month = newDate.getMonth();
      // let year = newDate.getYear();

      // let hour = newDate.getHours();
      // let min = newDate.getMinutes();
      // let sec = newDate.getSeconds();
      // return (
      //   day +
      //   " " +
      //   monthNames[month] +
      //   " " +
      //   (year + 543 + 1900) +
      //   " " +
      //   hour +
      //   ":" +
      //   min +
      //   ":" +
      //   sec
      // );
      return day + " " + month + " " + year;
    },
    getMonths: function() {
      var localApp = this;
      axios
        .get("/api/master/month", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterMonth = response.data.data;

            localApp.selectedMonth = "";
            localApp.selectedYear = "";

            // localApp.selectedMonth = moment().month() + 1;
            // localApp.selectedYear = moment().year() + 543;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getAgents: function() {
      var localApp = this;
      axios
        .get("/api/master/agent", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterAgent = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    onSelectMonth(event) {
      this.loadInsuranceByDate(event.target.value);
    },
    onSelectYear(event) {
      this.loadInsuranceByDate(event.target.value);
    },
    onSelectAgent: function(event) {
      this.loadInsuranceByDate(event.target.value);
    },
    loadInsuranceByDate: function() {
      var localApp = this;
      axios
        .get(
          "/api/insurance/date?month=" +
            this.selectedMonth +
            "&year=" +
            this.selectedYear +
            "&agent=" +
            this.selectedAgent,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.$emit("update:insurances", response.data.data.data);
          localApp.$emit("update:total", response.data.data.total);
        })
        .catch(function() {
          localApp.kick();
        });
    },
    goTo(key) {
      let routeData = this.$router.resolve({
        path: "/customerInsuranceDetail/" + key,
      });
      window.open(routeData.href, "_blank");
    },
    openFile(path) {
      window.open("/storage/" + path, "_blank");
    },
    onExport() {
      let jsonData = [];
      if (this.insurances.length !== 0) {
        this.insurances.forEach((item) => {
          let jsonObject = {};
          jsonObject["ตัวแทน"] = item.get_agent ? item.get_agent.name : "";
          jsonObject["เบอร์โทร"] = item.tel;
          jsonObject["ชื่อ-สกุล"] = item.name;
          jsonObject["บริษัท"] = item.company ? item.company.name : "";
          jsonObject["ทะเบียน"] = item.license_plate;
          jsonObject["วันหมดอายุ ประกัน"] = this.formatDate(
            item.cover_end_date
          );
          jsonObject["ยี่ห้อ/รุ่น"] = item.get_brand ? item.get_brand.name : "";
          jsonObject["เลขตัวถัง"] = item.body_number;
          jsonObject["เลขกรมธรรม์"] = item.policy_number;
          jsonObject["วันหมดอายุภาษี"] = this.formatDate(item.tax_due_date);
          jsonObject["เลขบัตรปชช."] = item.identity_no;
          jsonObject["ที่อยู่"] =
            item.address +
            " ต." +
            (item.getsub_district ? item.getsub_district.name : "") +
            " อ." +
            (item.getdistrict ? item.getdistrict.name : "") +
            " จ." +
            (item.getprovince ? item.getprovince.name : "");
          jsonObject["เบี้ยประกัน"] = item.insurance_premium;
          jsonData.push(jsonObject);
        });
        const dataWS = XLSX.utils.json_to_sheet(jsonData);
        const wb = XLSX.utils.book_new();
        var wscols = [
          { wch: 10 },
          { wch: 10 },
          { wch: 20 },
          { wch: 8 },
          { wch: 7 },
          { wch: 15 },
          { wch: 10 },
          { wch: 20 },
          { wch: 20 },
          { wch: 15 },
          { wch: 14 },
          { wch: 30 },
          { wch: 10 },
        ];

        dataWS["!cols"] = wscols;
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(wb, "export.xlsx");
      }
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.getMonths();
      this.getAgents();
      this.lvl = localStorage.level;
    }
  },
};
</script>
<style>
.table td,
.btn-sm,
.text-sm {
  font-size: 1rem !important;
}
.table thead th,
.table th {
  font-size: 0.9rem !important;
}

.h3,
h3 {
  font-size: 1.2rem !important;
}
.cutname {
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
